import { DefaultButton, ImageBase, Label, Panel, PanelType, PrimaryButton, Stack, TextField, Toggle } from "@fluentui/react";
import React, { useEffect, useRef, useState } from "react";
import { IUbicacionNuevo } from "../../../../interfaces/ubicacion/IUbicacion";
import UbicacionService from "../../../../services/ubicacionesServices";
import { fileToBase64 } from "../../../../utils/Helper/detalleArchivoHelper";
interface CrearUbicacionProps {
  isOpen: boolean;
  onDismiss: () => void;
  setUpActualizar: () => void;
}

const CrearUbicacion: React.FunctionComponent<CrearUbicacionProps> = (prop) => {
  const [formularioInputs, setformularioInputs] = useState<IUbicacionNuevo | undefined>();
  // TextField validar ingreso de dato
const [nameData,setNameData]= useState("");
const [codData, setCodData]= useState("");
const [habilitarBoton, sethabilitarBoton]= useState(true)
const imageInputRef = useRef<HTMLInputElement>(null);

  function _onChangeLE(_: React.MouseEvent<HTMLElement>, checked?: boolean) {
    setformularioInputs({ ...formularioInputs, lugarDeEmbarque: checked })
  };
  function _onChangeLA(_: React.MouseEvent<HTMLElement>, checked?: boolean) {
    setformularioInputs({ ...formularioInputs, lugarAutorizado: checked })
  };
  function _onChangeVA(_: React.MouseEvent<HTMLElement>, checked?: boolean) {
    setformularioInputs({ ...formularioInputs, viajeAutorizado: checked })
  };

  const onChangeInputNm = (_: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
    if (newValue !== undefined) {
      setNameData(newValue)
      setformularioInputs({ ...formularioInputs, nombre: newValue })
    }
  };
  const onChangeInputCod = (_: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
    if (newValue !== undefined) {
      setCodData(newValue)
      setformularioInputs({ ...formularioInputs, codigo: newValue })
    }
  };
/* Validaciones para habilitar BOTON REGISTRAR */
  useEffect(()=>{
    if(nameData == "" ||codData == "" ){
      sethabilitarBoton(true)
    }else {
      sethabilitarBoton(false)

    }
  
  },[nameData,codData])

  const onClickRegistrar = () => {
    if (formularioInputs !== undefined) {
      UbicacionService.ubicacionCrear({ ...formularioInputs, visibleComboFicha: true }).then(
        (res) => {
          if (res.status == 200) {
            prop.setUpActualizar()
          }
          prop.onDismiss()
        }
      )
        .catch(
          (e: Error) => {
            console.log(e.message)
          }
        )
    }
  }
  const gapb = { childrenGap: 5 }
  const onRenderFooterContent = React.useCallback(
    () => (
      <div>
        <Stack horizontal horizontalAlign="end" tokens={gapb} >
          <PrimaryButton onClick={onClickRegistrar} disabled={habilitarBoton} styles={{ root: { marginLeft: "30px" } }} >
            Registrar
          </PrimaryButton>
          <DefaultButton onClick={prop.onDismiss} styles={{ root: { marginLeft: "0px" } }}>Cancelar</DefaultButton>
        </Stack>
      </div>
    ),
    [formularioInputs],
  );

  const onChangeImagen = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files !== null) {
      const file = event.target.files[0];
      fileToBase64(file, (err: any, result: any) => {
        if (result) {
          setformularioInputs({ ...formularioInputs, imagenReferencial: result, imagenReferencialExtension: file.name.split(".").pop() })
        }
        if (err) {
          console.error(err)
        }
      })
    }
  }

  const alSeleccionarImagen = () => {
    imageInputRef.current?.click();
  }

  return (
    <>
      <Panel
        headerText="Nueva Ubicación"
        isOpen={prop.isOpen}
        onDismiss={prop.onDismiss}
        type={PanelType.medium}
        closeButtonAriaLabel="Close"
        onRenderFooterContent={onRenderFooterContent}
        isFooterAtBottom={true}
      >
        <TextField label="Nombre"  onChange={onChangeInputNm}  />
          <TextField label="Código" onChange={onChangeInputCod} />

          <Stack >
            <Toggle
              label="Lugar de Embarque"
              // defaultChecked
              onText="Sí"
              offText="No"
              onChange={_onChangeLE} />
            <Toggle
              label="Lugar Autorizado"
              // defaultChecked
              onText="Sí"
              offText="No"
              onChange={_onChangeLA} />

            <Toggle
              label="Viaje Autorizado"
              // defaultChecked
              onText="Sí"
              offText="No"
              onChange={_onChangeVA} />

            <>
              <Label>Imagen referencial</Label>
              <input ref={imageInputRef} type="file" accept="image/*" multiple={false} onChange={onChangeImagen} style={{ display: 'none' }} />
              <DefaultButton onClick={alSeleccionarImagen} style={{ marginBottom: '10px' }} >Seleccionar Imagen</DefaultButton>
              <ImageBase src={formularioInputs?.imagenReferencial} styles={{ root: { margin: 'auto' }, image: { maxHeight: '300px' }}} />
            </>

          </Stack>
      </Panel>
    </>
  );

}

export default CrearUbicacion;
